<template>
  <div class="container mb-25">
    <div class="row justify-content-center">
      <div class="col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6">
        <div class="card card-prelogin border-0 rounded-0 bg-white authentication-card">
          <div class="card-body letter-spacing">
            <h4 class="fw-bold mb-0">
              {{ $t('feature.auth.$login.title') }}
            </h4>
            <form id="login-form" v-on:submit="submit">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.otp.label') }}
                </label>
                <input type="text" title="OTP" class="form-control shadow-none text-black" v-model="otp"
                  :class="[{ 'is-invalid': submitted && !OTPIsValid }]" :placeholder="$t('form.otp.placeholder')"
                  required />
                  <div class="form-messages mt-2 px-1" >
                  <p class="small lh-1 m-0 mt-1" v-html="`*${ $t('feature.auth.$reset_password.expires_in', {time: expires_in}) }`"></p>
                  <!-- <template v-if="errors?.code ?? false">
                    <p v-for="error in errors.code" :key="error" class="small text-danger lh-1 m-0 mt-1">{{ error }}</p>
                  </template> -->
                </div>
              </div>
              
              <button class="default-btn transition fw-medium fs-md-15 fs-lg-16 d-block w-100" type="submit"
                v-on:click="setPristine" v-if="!loading">
                {{ $t('cta.login') }}
              </button>
              <SpinnerLoading v-else />
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- ERROR MESSAGE -->
    <div class="row justify-content-center">
      <div class="col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6">
        <div class="alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0"
          role="alert" id="errorMessage">
          <strong>{{ errorMessage }}</strong>
          <button type="button" class="btn-close" v-on:click="hideError" aria-label="Close"></button>
        </div>
      </div>
    </div>
  </div>
  <AlertModal id="alertModal" @confirm="resendRequest()" :title="$t('feature.auth.$reset_password.code_expired')" :message="$t('feature.auth.$reset_password.code_expired_message')"></AlertModal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import stateStore from "../../../utils/store";
import API from '../../../services/api/api.service';
import { Alert, Modal } from "bootstrap";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import AlertModal from "@/components/Widgets/AlertModal.vue";
import OTPstore from "@/utils/otp.store";

export default defineComponent({
  name: "OTPLoginVerifyForm",
  components: {
    SpinnerLoading,
    AlertModal
  },
  data: () => {
    return {
      loading: false,
      otp: '',
      submitted: false,
      errorMessage: '',
      errorAlert: undefined,
      timer: undefined,
      alertModal: undefined,
      expires_in: 60 * 5,
      errors: undefined as any,
    } as {
      loading: boolean,
      otp: string,
      submitted: boolean,
      errorAlert?: Alert,
      errorMessage?: string,
      timer?: number,
      alertModal?: Modal,
      expires_in: number,
      errors?: any,
    }
  },
  mounted() {
    this.errorMessage = this.$t('error.something_went_wrong');
    this.errorAlert = new Alert('#errorMessage');
    this.timer = setInterval(this.countdown, 1000);
    this.alertModal = new Modal('#alertModal', {});
  },
  computed: {
    OTPIsValid() {
      return this.otp.length != 0;
    }
  },
  methods: {
    submit(e) {
      this.submitted = true;
      e?.preventDefault();
      this.login();
    },
    login() {
      this.loading = true;
      API.verifyOTP(OTPstore.getLoginChallangeToken() ?? '', this.otp).then((loginRes) => {
        stateStore.login(loginRes.data);
        OTPstore.clearLoginChallangeToken();
        API.introspection().then((introspectionRes) => {
          stateStore.introspection(introspectionRes.data);
          if(stateStore.user?.info?.preference?.language_code == undefined) {
            API.setLanguage(this.$i18n.locale).then(() => {}).catch((error) => {
              console.error("SET_LANGUAGE_ERROR:", error);
            });
          }
          this.$router.push('/');
        }).catch((error) => {
            this.errors = error.response?.data?.errors;
            this.showError(error);
        }).finally(() => {
          this.loading = false;
        });
      }).catch((error) => {
        this.errors = error.response?.data?.errors;
        this.showError(error);
      }).finally(() => {
        this.loading = false;
      });
    },
    setPristine() {
      this.submitted = true;
    },
    showError(error?: any) {
      if ('response' in error) {
        this.errorMessage = error.response?.data?.message ?? this.$t('error.something_went_wrong');
      } else {
        this.errorMessage = this.$t('error.connection_error');
      }
      const error_element = document.getElementById('errorMessage');
      error_element?.classList.add('show');
      setTimeout(() => {
        this.hideError();
      }, 5000)
    },
    hideError() {
      const error = document.getElementById('errorMessage');
      error?.classList.remove('show');
    },
    countdown() {
      this.expires_in --;
      if(this.expires_in === 0) {
        this.stopTimer(); 
        this.alertModal?.show();
        setTimeout(this.resendRequest, 5000)
      }
    },
    resendRequest() {
      this.$router.push({path: '/login'})
      this.alertModal?.hide();
    },
    stopTimer() {
      console.log('STOP_TIMER');
      clearInterval(this.timer);
    },
  },
  deactivated() {
    this.stopTimer();
  },
  unmounted() {
    this.stopTimer();
  },
});
</script>